import { createReducer } from "reduxsauce";

import ReducerRegister from "../../../ReducerRegister";
import EditService from "../../../../services/screens/admin/bbs/EditService";
import { ActionTypes } from "../../../actionTypes/screens/admin/bbs/EditActionTypes";
import AsyncActionReducers from "../../../AsyncActionReducers";

import UIDs from "../../../../UIDs";

const uid = UIDs.screens.admin.bbs.edit;

//
// Actions
//
const Actions = {
    loadScreenViewAsync: vo => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.LOAD_SCREEN_VIEW_ASYNC, vo });

            EditService.loadScreenView(
                vo,
                response => {
                    dispatch(Actions.loadScreenViewSuccess(response));
                },
                error => {
                    dispatch(Actions.loadScreenViewFailure(error));
                }
            );
        };
    },

    loadScreenViewSuccess: data => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_SUCCESS,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        postReducer: loadScreenViewSuccessPostReducer,
        data
    }),

    loadScreenViewFailure: error => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_FAILURE,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        error
    }),

    saveAsync: vo => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.SAVE_ASYNC, vo });

            EditService.save(
                vo,
                response => {
                    dispatch(Actions.saveSuccess(response));
                },
                error => {
                    dispatch(Actions.saveFailure(error));
                }
            );
        };
    },

    saveSuccess: data => ({
        type: ActionTypes.SAVE_SUCCESS,
        parentType: ActionTypes.SAVE_ASYNC,
        data
    }),

    saveFailure: error => ({
        type: ActionTypes.SAVE_FAILURE,
        parentType: ActionTypes.SAVE_ASYNC,
        error
    }),

    selectClass: id => ({
        type: ActionTypes.SELECT_CLASS,
        id
    }),
};

//
// Initial State
//
const INITIAL_STATE = {
    postInfo: null,
    classList: [],
    selectedClasses: new Set(),
};

//
// Reducers
//
const loadScreenViewSuccessPostReducer = (state, { data }) => {
    let setClassList = new Set();
    for(var x=0;x<data.classList.length;x++)
    {
        setClassList.add(data.classList[x]["id"]);
    }

    let newSelectedClasses = new Set();
    if (data.postInfo && data.postInfo.classId) {
        if(setClassList.has(data.postInfo.classId)){
            newSelectedClasses.add(data.postInfo.classId);
        }
    } else if (data.postInfo && data.postInfo.classPostList && data.postInfo.classPostList.length > 0) {
        var arrClassId = data.postInfo.classPostList;
        for(var i=0;i<arrClassId.length;i++){
            if(setClassList.has(arrClassId[i]["id"])){
                newSelectedClasses.add(arrClassId[i]["id"]);
            }
        }
    }
    return { ...state, postInfo: data.postInfo, classList: data.classList, selectedClasses: newSelectedClasses };
};

const newReducer = (state) => {
    return { ...state, book: {} };
};

const selectClassReducer = (state, { id }) => {
    let selectedClasses = new Set(state.selectedClasses);

    if (selectedClasses.has(id)) {
        selectedClasses.delete(id);
    } else {
        selectedClasses.add(id);
    }

    return { ...state, selectedClasses };
};


// Use reduxsauce's createReducer to make it clearer for
// each action handler
const mergedReducer = createReducer(INITIAL_STATE, {
    [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.SAVE_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.SAVE_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.SAVE_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.SELECT_CLASS]: selectClassReducer,
});

// Enable dynamically register and unregister reducer
const reducer = new ReducerRegister(uid, mergedReducer);

export { ActionTypes, Actions, reducer, INITIAL_STATE };
